import { cn } from '@utils/cn';
import { type ComponentPropsWithoutRef } from 'react';

const TimeLineItemCard = ({
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      className={cn('ml-10 rounded-md border bg-card p-3', className)}
      {...props}
    >
      {children}
    </div>
  );
};

export { TimeLineItemCard };
